import React, { useContext } from "react";
import { AppContext } from "../App";
import { FiMail, FiPhone, FiMapPin, FiArrowUpRight, FiLayers, FiZap, FiTarget } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";

export default function ContactUsContent() {
  const appContext = useContext(AppContext);
  const contactData = {
    email: "info@werenium.com",
    phone: "+255 758 779 913",
    whatsapp: "255758779913",
    address: "Tabata Kimanga, Dar es Salaam"
  };

  return (
    <section className="contact-premium-section">
      <style>{`
        .contact-premium-section {
          background: #ffffff;
          color: #0f172a;
          font-family: 'Inter', system-ui, sans-serif;
          padding: 120px 0;
          position: relative;
          overflow: hidden;
        }

        /* ── Minimalist Faded Doodles ── */
        .doodle {
          position: absolute;
          color: #f1f5f9; /* Very faded, barely visible */
          z-index: 0;
          animation: slowFloat 12s infinite ease-in-out;
          pointer-events: none;
        }

        @keyframes slowFloat {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-30px) rotate(5deg); }
        }

        .minimal-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
          position: relative;
          z-index: 1;
        }

        .minimal-title {
          font-size: 4rem;
          font-weight: 800;
          letter-spacing: -0.05em;
          line-height: 1;
          margin-bottom: 28px;
        }

        .minimal-title span {
          background: linear-gradient(135deg, var(--primaryColor), var(--secondaryColor));
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .lead-text {
          color: #64748b;
          font-size: 1.15rem;
          line-height: 1.7;
          max-width: 480px;
          margin-bottom: 48px;
        }

        /* ── Modern Location Pill (Redesigned) ── */
        .location-card {
          display: inline-flex;
          align-items: center;
          gap: 20px;
          padding: 12px 12px 12px 24px;
          background: #f8fafc;
          border-radius: 100px;
          border: 1px solid #e2e8f0;
          transition: 0.3s;
        }

        .location-card:hover {
          border-color: var(--primaryColor);
          background: #fff;
        }

        .loc-icon-circle {
          width: 44px;
          height: 44px;
          background: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          color: var(--primaryColor);
        }

        .loc-text {
          font-weight: 700;
          font-size: 0.9rem;
          color: #1e293b;
          letter-spacing: -0.01em;
        }

        /* ── Clean Contact Methods ── */
        .contact-methods-grid {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .contact-card {
          display: flex;
          align-items: center;
          padding: 24px 32px;
          background: #fff;
          border: 1px solid #f1f5f9;
          border-radius: 20px;
          text-decoration: none;
          transition: all 0.3s ease;
          color: inherit;
        }

        .contact-card:hover {
          border-color: #e2e8f0;
          transform: scale(1.02);
          box-shadow: 0 10px 30px rgba(0,0,0,0.03);
        }

        .card-icon-box {
          width: 52px;
          height: 52px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.3rem;
        }

        .card-content {
          flex: 1;
          margin-left: 20px;
        }

        .card-label {
          display: block;
          font-size: 0.7rem;
          font-weight: 800;
          text-transform: uppercase;
          color: #94a3b8;
          margin-bottom: 2px;
        }

        .card-value {
          font-size: 1.2rem;
          font-weight: 700;
          color: #0f172a;
        }

        .arrow-link {
          color: #cbd5e1;
          transition: 0.3s;
        }

        .contact-card:hover .arrow-link {
          color: var(--primaryColor);
          transform: translateX(5px);
        }

        @media (max-width: 992px) {
          .minimal-grid { grid-template-columns: 1fr; text-align: center; gap: 50px; }
          .lead-text { margin: 0 auto 40px; }
          .location-card { margin-top: 20px; }
          .minimal-title { font-size: 3rem; }
        }
      `}</style>

      {/* Subtle Minimalist Doodles */}
      <FiLayers className="doodle" style={{ top: '10%', left: '5%', fontSize: '120px', animationDelay: '0s' }} />
      <FiZap className="doodle" style={{ bottom: '15%', left: '15%', fontSize: '90px', animationDelay: '3s' }} />
      <FiTarget className="doodle" style={{ top: '20%', right: '5%', fontSize: '150px', animationDelay: '6s' }} />

      <div className="container">
        <div className="minimal-grid">
          
          <div className="minimal-info">
            <h1 className="minimal-title">Transforming <br/>ideas into <span>digital reality.</span></h1>
            
            <p className="lead-text">
              We bridge the gap between complex technology and intuitive user experiences. Choose a channel below to sync with our team.
            </p>

            <div className="location-card">
              <div className="loc-text">{contactData.address}</div>
              <div className="loc-icon-circle">
                <FiMapPin size={18}/>
              </div>
            </div>
          </div>

          <div className="contact-methods-grid">
            
            {/* WhatsApp Card */}
            <a href={`https://wa.me/${contactData.whatsapp}`} target="_blank" rel="noreferrer" className="contact-card">
              <div className="card-icon-box" style={{background: '#f0fdf4', color: '#22c55e'}}>
                <FaWhatsapp />
              </div>
              <div className="card-content">
                <span className="card-label">Instant Sync</span>
                <span className="card-value">WhatsApp Chat</span>
              </div>
              <FiArrowUpRight className="arrow-link" />
            </a>

            {/* Phone Card */}
            <a href={`tel:${contactData.phone}`} className="contact-card">
              <div className="card-icon-box" style={{background: '#f0f9ff', color: '#0ea5e9'}}>
                <FiPhone />
              </div>
              <div className="card-content">
                <span className="card-label">Direct Line</span>
                <span className="card-value">{contactData.phone}</span>
              </div>
              <FiArrowUpRight className="arrow-link" />
            </a>

            {/* Email Card */}
            <a href={`mailto:${contactData.email}`} className="contact-card">
              <div className="card-icon-box" style={{background: '#faf5ff', color: '#a855f7'}}>
                <FiMail />
              </div>
              <div className="card-content">
                <span className="card-label">Enquiries</span>
                <span className="card-value">{contactData.email}</span>
              </div>
              <FiArrowUpRight className="arrow-link" />
            </a>

          </div>
        </div>
      </div>
    </section>
  );
}